import React from 'react';
import { WysiwygField } from '../../../components';

const TextBlock = ({ entity }) => {
  return (
    <WysiwygField
      property="schema:text"
      className="TextBlock"
      html={entity.getIn(['body', 0, 'processed'])}
    />
  );
};

export default TextBlock;
